import { normalizeApiError } from '../api/apiError';

const CODE_MESSAGES: Record<string, string> = {
  VISITOR_ALREADY_EXISTS:
    'A visitor with this phone number or email is already registered.',
  VISITOR_FACE_ALREADY_REGISTERED:
    'This face is already registered to another visitor.',
  VISITOR_FACE_NOT_MATCHED:
    'Face not recognised. This visitor is not registered — please register them first.',
  VISITOR_ALREADY_CHECKED_IN:
    'This visitor is already checked in. Check them out before a new visit.',
  VISITOR_NOT_CHECKED_IN: 'This visitor is not checked in, so they cannot check out.',
  VISITOR_NOT_FOUND: 'This visitor could not be found.',
  VISITOR_CURRENTLY_INSIDE: 'Check the visitor out before removing them.',
  VISITOR_CONSENT_REQUIRED:
    "Confirm the visitor's consent to face capture before registering.",
  VISITOR_FACE_PROVIDER_UNSUPPORTED:
    'Visitor face recognition is not available for this organization. Contact your administrator.',
  VISITOR_MODULE_NOT_INSTALLED:
    'Visitor management is not set up on the server yet. Contact your administrator.',
  FACE_NOT_DETECTED: 'No face was detected. Make sure one face is clearly visible.',
  FACE_NOT_FOUND: 'No face was detected. Make sure one face is clearly visible.',
  INVALID_FACE_IMAGE: 'Use a clear photo that shows exactly one face.',
  FACE_IMAGE_REQUIRED: 'Capture or upload a face photo.',
  FACE_IMAGE_TYPE_NOT_SUPPORTED: 'Use a JPEG, PNG, BMP or GIF photo.',
  FACE_IMAGE_TOO_LARGE: 'The photo is too large. Use a smaller image.',
  FACE_IMAGE_TOO_SMALL: 'The photo is too small. Use a clearer image.',
  CAPTURE_FAILED: 'Could not read the photo. Please try again.',
};

export function visitorErrorMessage(
  error: unknown,
  fallback = 'Something went wrong. Please try again.',
): string {
  const apiError = normalizeApiError(error);
  if (apiError.code && CODE_MESSAGES[apiError.code]) {
    return CODE_MESSAGES[apiError.code];
  }
  return apiError.message || fallback;
}
